import React from 'react';
import styles from './Onboarding.module.css';
import Topbar from '../EngageAI/Topbar'
import { LINKS } from '../../Utils/constants';


const HubSpotRedirectMember = () => {
    return (
        <div>
            <div>
                <Topbar/>
                <div className={`${styles['f-20']} ${styles['center-align']} mb-3`}>
                <iframe width="900" height="505" src="https://www.youtube.com/embed/vcf0GjSuYEc" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
                </div>
                <div className={``}  >
                    <div className={`${styles['f-30']} ${styles['center-align']} ${styles['fw-b']} mb-3 `}>
                        You already have an account!
                    </div>
                    <div className={`${styles['f-20']} ${styles['center-align']} mb-3`}>
                        Just a few more steps and you can start moving prospects stuck in your pipeline.
                    </div>
                    <div className={`${styles['w-680']} ${styles['f-16']}`} style={{margin:"auto"}}>
                        <ol>
                            <li>Download the <a href={LINKS.CHROME_EXTENSION} target='__blank' style={{color:"#3947A8"}}>Kynzo Chrome Extension</a> to activate LinkedIn post-tracking.</li>
                            <li>Start nurturing prospects by adding their LinkedIn profiles to the <a href='https://apps.kynzo.io/' target='__blank' style={{color:"#3947A8"}}>Kynzo app</a>.</li>
                        </ol>
                    </div>
                    
                </div>
            </div>
        </div>
    ); 
}
export default HubSpotRedirectMember;